import React, {useEffect, useState} from 'react';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Captcha} from 'primereact/captcha';
import {Password} from "primereact/password";
import {AuthService} from "../../service/AuthService";
import {UnAuthService} from "../../service/UnAuthService";
import queryString from 'query-string';
import {getKeyValue, emailValidator} from "../../utils/Utils";
import {AppContext} from "../../HomePage";
import AuthLayout from "./AuthLayout";
import AuthField from "./AuthField";


const Recovery = (props) => {

    const {t, toast, setError, location, navigate} = React.useContext(AppContext);

    const[email, setEmail] = useState('');
    const[password, setPassword] = useState('');
    const[isToken, setIsToken] = useState(false);
    const[captchaValid, setCaptchaValid] = useState(false);
    const[emailError, setEmailError] = useState('');
    const[passwordError, setPasswordError] = useState('');
    const[submitted, setSubmitted] = useState(false);
    const[formError, setFormError] = useState('');
    const[submitting, setSubmitting] = useState(false);

    useEffect(() => {
        const url = location.search;
        const params = queryString.parse(url);
        if(params.token) {
            setIsToken( true );
        }
        if(AuthService.loggedIn()) {
            navigate("/");
        }
    }, [])

    const captchaResponse = () => {
        setCaptchaValid(true);
    };

    const validateEmail = (value) => value.trim() === '' ? t('login.email_required') : emailValidator(value.trim(), t);
    const validatePassword = (value) => value.length < 8 ? t('login.password_rule_min') : '';

    const sendRecoveryLink = (event) => {

        event.preventDefault();

        if (submitting)
            return;

        setFormError('');
        setEmailError('');
        setSubmitted(true);

        const trimmedEmail = email.trim();
        const error = validateEmail(email);
        setEmailError(error);
        if (error !== '')
            return;

        if(!captchaValid)
        {
            toast.current.show({severity: "error", summary: t('login.captcha_summary'), detail: t('login.captcha_detail')});
            return;
        }

        setSubmitting(true);

        UnAuthService.sendRecoveryLink(trimmedEmail).then(() => {
            navigate("/login?recover=1");
        }).catch(error => {
            const data = error.response && error.response.data;
            const translated = data && data.error_key ? t(data.error_key) : null;
            if (translated && translated !== data.error_key) {
                setFormError(translated);
            } else {
                setError(error);
                setError(null);
            }
            setSubmitting(false);
        });
    };

    const resetPassword = (event) => {

        event.preventDefault();

        if (submitting)
            return;

        setFormError('');
        setPasswordError('');
        setSubmitted(true);

        const error = validatePassword(password);
        if (error !== '')
        {
            setPasswordError(error);
            return;
        }

        const url = location.search;
        const params = queryString.parse(url);

        setSubmitting(true);

        UnAuthService.resetPassword(password, params.token).then(() => {
            navigate("/login?recover=2");
        }).catch(error => {
            const data = error.response && error.response.data;
            const translated = data && data.error_key ? t(data.error_key) : null;
            if (translated && translated !== data.error_key) {
                setFormError(translated);
            } else {
                setError(error);
                setError(null);
            }
            setSubmitting(false);
        });
    };

    return <AuthLayout title={isToken ? t('login.reset_title') : t('login.recovery_title')}
                       subtitle={isToken ? t('login.reset_subtitle') : t('login.recovery_subtitle')}
                       footer={<button type="button" className="auth-ux__link"
                                       onClick={() => navigate("/login")}>{t('login.back_to_login')}</button>}>

        {!isToken &&
        <form onSubmit={sendRecoveryLink} noValidate>

            {formError && <div className="auth-ux__form-error" role="alert">{formError}</div>}

            <AuthField id="email" label={t('user.email')} error={emailError}>
                <InputText name="email" type="email" inputMode="email" autoComplete="username"
                           value={email} onChange={(e) => {
                               const value = getKeyValue(e).value;
                               setEmail(value);
                               if (submitted)
                                   setEmailError(validateEmail(value));
                           }}/>
            </AuthField>

            <div className="auth-ux__field">
                <Captcha siteKey="6LfwsuYUAAAAAHfOxoAxTJYehxxhfLO_SSJZDaaL" onResponse={captchaResponse}/>
            </div>

            <Button type="submit" label={t('user.send_recovery_link')} icon="pi pi-envelope"
                    className="auth-ux__submit" disabled={submitting} loading={submitting}/>
        </form>}

        {isToken &&
        <form onSubmit={resetPassword} noValidate>

            {formError && <div className="auth-ux__form-error" role="alert">{formError}</div>}

            <AuthField id="password" label={t('user.password')} error={passwordError}
                       hint={t('login.password_rule_min')}>
                <Password name="password" feedback={true} toggleMask={true} autoComplete="new-password"
                          value={password} onChange={(e) => {
                              const value = getKeyValue(e).value;
                              setPassword(value);
                              if (submitted)
                                  setPasswordError(validatePassword(value));
                          }}/>
            </AuthField>

            <Button type="submit" label={t('user.reset_password')} icon="pi pi-key"
                    className="auth-ux__submit" disabled={submitting} loading={submitting}/>
        </form>}
    </AuthLayout>;
};
export default Recovery;
